module.exports = __webpack_public_path__ + "static/media/logo-small.82d24018.svg";